export const getCurrentTotal = ({ splits }) => {
    const total = splits.reduce((sum, { netValue }) => sum + netValue, 0)
    return Math.round((total || 0) * 100) / 100
}